export function createDistributorOption(distributor) {
  if (!distributor) return null;

  const email = typeof distributor.email === 'string' ? distributor.email.trim() : '';
  const company = typeof distributor.company === 'string' ? distributor.company.trim() : '';

  return {
    value: String(distributor.id),
    label: email || company,
    rawName: email || company,
    company,
    email,
  };
}

export function getDistributorDisplayLabel(distributor) {
  return createDistributorOption(distributor)?.label || '';
}
